import { useState } from "react";
import { ExcelData, MatchingData } from "@/lib/types";
import { Collection } from "@/lib/api";
import ChatInterface from "@/components/ChatInterface";
import DataDisplay from "@/components/DataDisplay";
import Sidebar from "@/components/Sidebar";

const Index = () => {
  const [excelData, setExcelData] = useState<ExcelData | null>(null);
  const [matchingData, setMatchingData] = useState<MatchingData | null>(null);
  const [selectedCollection, setSelectedCollection] = useState<Collection | null>(null);

  const handleFileLoaded = (data: ExcelData) => {
    setExcelData(data);
  };

  const handleMatchingData = (data: MatchingData) => {
    setMatchingData(data);
  };

  const handleCollectionSelect = (collection: Collection) => {
    setSelectedCollection(collection);
  };

  return (
    <div className="flex h-screen">
      <Sidebar
        onFileLoaded={handleFileLoaded}
        onCollectionSelect={handleCollectionSelect}
        selectedCollection={selectedCollection}
      />
      
      <main className="flex-1 ml-80 p-8">
        <div className="max-w-4xl mx-auto">
          {selectedCollection ? (
            <div className="space-y-8">
              <div className="mb-8">
                <h2 className="text-2xl font-bold mb-2">Chat with {selectedCollection.name}</h2>
                <p className="text-gray-600">
                  {selectedCollection.count} documents available for querying
                </p>
              </div>
              
              <ChatInterface
                excelUploaded={true}
                onMatchingData={handleMatchingData}
              />
              {matchingData && <DataDisplay matchingData={matchingData} />}
            </div>
          ) : (
            <div className="text-center text-gray-500 mt-20">
              <h2 className="text-xl font-semibold mb-2">Welcome to Excel Chat</h2>
              <p>Select a collection from the sidebar to get started</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Index;
